import source from "@/messages/quiz-step-source.json";
import draft from "@/messages/mandarin-quiz-step.json";
import type { Locale } from "./locales";

export function quizStepCopy(locale: Locale = "en"): typeof source {
  return locale === "en" ? { ...source } : { ...draft };
}
